import React, { FC, useEffect } from 'react';

import { Field } from 'redux-form';
import { TranslationKey, useTranslations } from '@lang';

import { useIsDesktop } from '@common/hooks/useIsDesktop';

import { ReduxFormSelect } from '../../../components/FormElements/BlockSelectField';
import TimeSlotOptionHOC from '../TimeSlotOptionHOC';

const TimeSlotOption = (props) => <TimeSlotOptionHOC parentType="Option" {...props} />;
const TimeSlotValue = (props) => <TimeSlotOptionHOC parentType="SingleValue" {...props} />;

export const TimeSlotSelector: FC<{
  arrivalTimesOptions;
  change;
  disabled: boolean;
  labelTranslation?: TranslationKey;
  showPerPerson?: boolean;
}> = ({
  arrivalTimesOptions,
  change,
  disabled,
  labelTranslation = 'spa.selectArrival',
  showPerPerson,
}) => {
  const { t, formatTime } = useTranslations();
  const isDesktop = useIsDesktop();

  useEffect(() => {
    if (arrivalTimesOptions.length === 1) {
      change('arrivalTime', arrivalTimesOptions[0]);
    }
  }, [arrivalTimesOptions[0]?.startDateTime]);

  return arrivalTimesOptions ? (
    <Field
      key={arrivalTimesOptions}
      component={ReduxFormSelect}
      components={{
        Option: (props) => TimeSlotOption({ ...props, showPerPerson }),
        SingleValue: (props) => TimeSlotValue({ ...props, showPerPerson }),
      }}
      getOptionValue={(option) => option.startDateTime}
      name="arrivalTime"
      readonly
      isSearchable={false}
      menuPlacement={isDesktop ? 'auto' : 'top'}
      label={t(labelTranslation)}
      isRequired
      options={arrivalTimesOptions}
      noOptionsMessage={() => t('treatment.noTimeslotsAvailable')}
      placeholder={t('product.selectPlaceholder')}
      useNativeDropdownOnMobile={true}
      renderMobileOption={(option) => formatTime(option.startDateTime)}
      handleAfterChange={(args) => {
        change('arrivalTime', args);
      }}
      id="time-slot-selector"
      isDisabled={disabled}
    />
  ) : null;
};
